import React, { useState } from 'react';
import { Input, Button, Form, message } from 'antd';
import { MobileOutlined } from '@ant-design/icons';
import { VerifyOtp } from '../../apis/Brand/Profile/VerifyOtp';
import { dispatch, useGlobalState } from '../../store/state';
import { useForm } from 'antd/lib/form/Form';
import { useHistory } from 'react-router-dom';
import { GetOtp } from '../../apis/Brand/Profile/GetOtp';
import { GetProfileDetails } from '../../apis/Brand/Profile/GetProfileDetails';
import { UpdatePhone } from '../../apis/Brand/Profile/UpdatePhone';
import { SignInBrandOrAgency } from '../../apis/Signin';


const { Item } = Form;
export const OtpValidationFormComponent = () => {
  const history = useHistory();
  const [user] = useGlobalState('user');
  const [OtpValidationForm] = useForm();
  const [resendTimer, setResendTimer] = useState(0);
  const [otpValidation, setOtpValidation] = useState({
    resend: false,
    success: false,
    errors: [],
  });
  const [editContact, setEditContact] = useState(false);
  const [phone, setPhone] = useState(user.phone || '');

  const onFinish = (values) =>{
    const _data = {
      phone: values.phone,
      otp: values.filled_otp,
    };
    VerifyOtp(_data).then(({ response, status }) =>{
      console.log('validation response', response);
      if (status === 200) {
        dispatch({
          type: 'SET_USER',
          payload: {
            ...user,
            ...response,
          },
        });
        setOtpValidation({
          ...otpValidation,
          success: true,
          errors: [],
        });
        OtpValidationForm.resetFields();

        setTimeout(() => {
          history.push('/brand');
        }, 0);
      } else {
        console.log('validation error', response);
        setOtpValidation({
          ...otpValidation,
          errors: response.errors,
        });
        // message.error("OTP Validated successfully!")
      }
    });
  };

  const refreshProfile = () =>{
    console.log('getting refresh');
    GetProfileDetails(user.accessToken).then(({ response, status }) =>{
      console.log('getting data', response);
      if (status === 200) {
        dispatch({
          type: 'SET_USER',
          payload: {
            ...user,
            ...response,
          },
        });
      } else {
        message.error('There is some issue with getting your profile details');
      }
    });
  };

  const updatePhone = async (data) => {
    // console.log()
    return await UpdatePhone(user.accessToken, data).then(({ status, response })=>{
      if (status === 200) {
        refreshProfile(); // refetch data in profile
        return true;
      } else {
        message.error('There is some issue with updating your phone number');
        return false;
      }
    });
  };

  // @note getting otp verify
  const getOtp = async () =>{
    // @note: timer Resending OTP
    let secondsToGo = 30;
    const timer = setInterval(() => {
      secondsToGo -= 1;
      setResendTimer(secondsToGo);
    }, 1000);
    setTimeout(() => {
      clearInterval(timer);
      setResendTimer(0);
    }, secondsToGo * 1000);

    // let _data = {
    //     phone:phoneSigninForm.getFieldValue('phone')
    // }
    let sendOtp = true;
    if (editContact) {
      const res = await updatePhone({ phone: phone });
      if (!res) {
        sendOtp = false;
      }
      setEditContact(false);
    }
    if (sendOtp) {
      const _data = {
        phone: phone,
      };
      GetOtp(user.token, _data).then(({ response, status })=>{
        if (status === 200) {
          message.success('OTP sent successfully');
          console.log('res', response);
          setOtpValidation({
            ...otpValidation,
            resend: 'Resend',
          });
        } else {
          clearInterval(timer);
          setResendTimer(0);
          message.error('There is some issue while sending OTP');
        }
      });
    }
  };


  return (
    <div>

      <Form
        form={OtpValidationForm}
        onFinish={onFinish}
        name="otp_validation_form"
        className="otp-validation-form"
        layout="vertical"
        initialValues={{
          phone: user.phone || undefined,
        }}
      >
        <div className="d-flex flex-wrap align-items align-items-start">
          <div className="col-12 px-0">
            <p className="mb-1">Provided contact number</p>
          </div>
          <div className="col-8 pl-0">
            <Item name="phone"
              className='mb-0'>
              <Input onChange={(e) => setPhone(e.target.value)}
                prefix={<MobileOutlined className="site-form-item-icon" />}
                type="number"
                size="large"
                disabled={!editContact}/>
            </Item>
          </div>
          <div className="col-4 px-0">
            <Button
              className="w-100 common_button py-2"
              disabled={resendTimer > 0 ? true : false}
              onClick={getOtp}
            >
              {/* {otpValidation.resend ? 'Resend':'Get OTP'} */}
              {otpValidation.resend ? `Resend ${resendTimer > 0 ? 'in '+resendTimer+'s':''}`:'Get OTP'}
            </Button>
          </div>
          <div className="col-12 px-0 mb-1">
            <p style={{ fontSize: '12px', color: 'grey' }}>Entered wrong contact number?
              <span style={{ color: '#8d2fc0', cursor: 'pointer' }}
                onClick={()=>{
                  setEditContact(!editContact);
                }}>Edit</span>
            </p>
          </div>
        </div>

        <div className="d-flex flex-wrap align-items align-items-start">
          <div className="col-5 px-0">
            <Item name="filled_otp"

              rules={[
                { required: true, message: 'Enter OTP you recevied' },
              ]}
            >
              <Input disabled={!otpValidation.resend}
                size="large"
                type="number"
                placeholder="Enter OTP"/>
            </Item>
          </div>
          <div className="col-7 pr-0">
            <Item>
              <Button htmlType="submit"
                className="common_button py-2"
                disabled={!otpValidation.resend}
              >Verify OTP</Button>
            </Item>
          </div>
          {/* <div className="col-4 pr-0">
                        <Item>
                            <Button type="link" className="p-0">Resend</Button>
                        </Item>
                    </div> */}
        </div>


      </Form>
      {otpValidation.success && <h6 className="text-success mt-3">OTP validated successfully!</h6>}
      {
        otpValidation.errors.length ?
          <div>
            <p className="text-danger mb-1"><strong>Failed to Validate OTP due to following reasons:</strong></p>
            <ul className="pl-3">
              {otpValidation.errors.map(({ msg }, index) =>(
                <li key={index}
                  className="text-danger">{msg}</li>
              ))}
            </ul>
          </div> :
          null
      }
    </div>
  );
};
